import { useEffect, useState } from 'react';
import { Button, Input } from '../ds/index.js';
import { PersonAvatar } from '../people/PersonAvatar.js';
import { useMembersStore, sessionInfo, loadMembers } from '../people/membersStore.js';
import { useCampusOnline } from '../people/presence.js';

/** Choisir à qui écrire (membres, hors soi), en ligne d'abord. */
export function NewMessagePicker({ onPick, onCancel }: { onPick: (userId: string) => void; onCancel: () => void }) {
  const members = useMembersStore((s) => s.members);
  const online = useCampusOnline();
  const [query, setQuery] = useState('');
  const { userId: me } = sessionInfo();
  useEffect(() => { void loadMembers(); }, []);
  const q = query.trim().toLocaleLowerCase('fr');
  const list = [...members.values()]
    .filter((m) => m.userId !== me && (!q || m.displayName.toLocaleLowerCase('fr').includes(q)))
    .sort((a, b) => Number(online.has(b.userId)) - Number(online.has(a.userId)) || a.displayName.localeCompare(b.displayName, 'fr'));
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1 }}>
      <div style={{ padding: '12px 16px', display: 'flex', gap: 8 }}>
        <Button variant="ghost" size="sm" icon="arrow-left" aria-label="Retour" onClick={onCancel} />
        <Input autoFocus aria-label="Écrire à" placeholder="Écrire à…" value={query} onChange={(e) => setQuery(e.target.value)} className="pl-grow" />
      </div>
      <ul style={{ listStyle: 'none', margin: 0, padding: '0 8px 16px', overflowY: 'auto' }}>
        {list.map((m) => (
          <li key={m.userId}>
            <button type="button" className="pl-menu-item" onClick={() => onPick(m.userId)}
              style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', minHeight: 44, padding: '4px 8px', borderRadius: 'var(--radius-md)', textAlign: 'left' }}>
              <PersonAvatar userId={m.userId} name={m.displayName} size={32} />
              <span style={{ flex: 1, fontSize: 'var(--text-sm)', fontWeight: 600 }}>{m.displayName}</span>
              {online.has(m.userId) && <span style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-secondary)' }}>en ligne</span>}
            </button>
          </li>
        ))}
        {list.length === 0 && <p className="pl-help" style={{ margin: 8 }}>Personne de ce nom.</p>}
      </ul>
    </div>
  );
}
